import Vue from 'vue'

Vue.component('CustomSearchTitleArea', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomSearchTitleArea`))
Vue.component('CustomStaticsArea', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomStaticsArea`))
Vue.component('CustomSelectionMap', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomSelectionMap`))
Vue.component('CustomParallaxArea', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomParallaxArea`))
Vue.component('CustomProductsSelector', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomProductsSelector`))
Vue.component('CustomHeader', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomHeader`))
Vue.component('CustomHeaderMobile', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomHeaderMobile`))
Vue.component('CustomFooter', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomFooter`))
Vue.component('CustomTourHeader', () => import(`../../projects/${process.env.PROJECT}/front/components/home/CustomTourHeader`))



// WEBPACK FOOTER //
// ./src/front/init/dynamic-components.js